class AdpMainBreadcrumbController {
  constructor() {
    this.name = 'adpMainBreadcrumb';
  }
}

export default AdpMainBreadcrumbController;



// WEBPACK FOOTER //
// ./src/app/components/adpMainBreadcrumb/adpMainBreadcrumb.controller.js